import { render } from "./Leslaboratoires.vue?vue&type=template&id=21698888&scoped=true&ts=true"
import script from "./Leslaboratoires.vue?vue&type=script&lang=ts"
export * from "./Leslaboratoires.vue?vue&type=script&lang=ts"

import "./Leslaboratoires.vue?vue&type=style&index=0&id=21698888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21698888"]])

export default __exports__